module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat4@3x-ac87d1012df6d4c01a957552df5fa17f.jpg";